/**
 * Avada 7.16+ wraps mega menu / media tray as awb-full-sections and runs
 * GSAP ScrollTrigger on them. These are overlay panels, not page sections —
 * disable that behavior so open/close toggles work again.
 */
function neutralizeHeaderOverlaySections() {
    var $mega = jQuery("#desktop_mega_menu").first();
    var $cart = jQuery("#desktop_media_cart").first();
    var $wrap = $mega.closest(".awb-full-sections, #fusion-scroll-section-1");

    if (!$wrap.length) {
        return;
    }

    if (window.ScrollTrigger && typeof ScrollTrigger.getAll === "function") {
        ScrollTrigger.getAll().forEach(function (st) {
            if (st.trigger === $wrap[0]) {
                st.kill(true);
            }
        });
    }

    if (window.gsap) {
        gsap.killTweensOf($wrap[0]);
        gsap.killTweensOf($wrap.children(".awb-full-section").toArray());
    }

    $wrap
        .data("full-sections-init", true)
        .attr("data-full-sections-init", "true")
        .addClass("awb-full-sections-disabled header-overlay-sections")
        .removeClass("awb-full-sections awb-full-sections-ready awb-full-sections-active");

    if ($wrap.parent().hasClass("awb-full-sections-wrap")) {
        $wrap.unwrap();
    }

    $wrap.find("> .fusion-scroll-section-nav").hide();

    $mega.add($cart).add($wrap.children(".awb-full-section")).css({
        opacity: "",
        visibility: "",
        transform: "",
        filter: "",
        "z-index": "",
        position: "",
        inset: "",
        top: "",
        left: "",
        right: "",
        bottom: "",
        width: "",
        height: ""
    });
}

jQuery(document).ready(function ($) {

    neutralizeHeaderOverlaySections();
    // Avada may init full-sections after our ready callback
    setTimeout(neutralizeHeaderOverlaySections, 0);
    jQuery(window).on("load", neutralizeHeaderOverlaySections);

    cartEvents();
    jQuery("a:not([tabindex])").attr("tabindex", "0");
    jQuery("#desktop_mega_menu").attr("aria-hidden", "true");
    jQuery("#desktop_mega_menu nav").attr("role", "navigation");
    if (jQuery(window).scrollTop() > 1) {
        jQuery(".fusion-tb-header").addClass("hide_notificaiton_bar");
    } else {
        jQuery(".fusion-tb-header").removeClass("hide_notificaiton_bar");
    }

    $('.slide_up_form_sec .gform_wrapper .gform_button.button').on('click', function () {
        setTimeout(() => {
            $('.slide_up_form_sec .gform_confirmation_wrapper .gform_confirmation_message').addClass("reduce_height");
        }, 500);
    });

    jQuery('img').bind('contextmenu', function(e) {
        return false;
    }); 

    $(".slide_up_form_sec_inner_title").click(function () {
        let hide_sec = $(this).parent().find(".gf_browser_chrome");
        let new_hide_sec = $(this).parent().find(".gform_confirmation_wrapper ");
        if (($(hide_sec).is(":hidden")) || ($(new_hide_sec).is(":hidden"))) {
            $(this).addClass("active");
            $(hide_sec).addClass("active");
            $(hide_sec).slideDown();
            $(new_hide_sec).addClass("active");
            $(new_hide_sec).slideDown();

        } else {
            $(this).removeClass("active");
            $(hide_sec).removeClass("active");
            setTimeout(() => {
                $(hide_sec).slideUp();
            }, 300);
            $(new_hide_sec).removeClass("active");
            setTimeout(() => {
                $(new_hide_sec).slideUp();
            }, 300);
        }
    });

    $('.post_with_image_and_title').each(function () {
        if ($(this).closest(".popular_posts_sec").length == 0) {
            let slider = $(this).find(".post_list_inner");
            $(slider).slick({
                infinite: false,
                dots: false,
                arrows: false,
                slidesToShow: 5,
                slidesToScroll: 1,
                responsive: [{
                        breakpoint: 1265,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            dots: true,
                        }
                    },
                    {
                        breakpoint: 601,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                        }
                    },
                ]
            });
        }
    });

    $(".media_cart_sec").each(function (index) {
        let slide = $(this).find('.cart_step_sec__inner__step_list__item');
        let slider = $(this).find('.cart_step_sec__inner__step_list');
        let dots = $(this).find('.slider_dots');
        if ($(slide).length > 1) {
            $(slider).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                arrows: false,
                prevArrow: $(this).find('.prev-slide'),
                nextArrow: $(this).find('.next-slide'),
                dots: true,
                appendDots: $(dots),
                responsive: [{
                        breakpoint: 1265,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 601,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: true,
                        }
                    },
                ]
            });
        }
    });

    $('.popular-posts-section .popular_posts_sec .post_with_image_and_title').each(function () {
        let slider = $(this).find(".post_list_inner");
        $(slider).slick({
            infinite: false,
            dots: false,
            arrows: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1265,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true,
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        dots: true,
                    }
                },
            ]
        });
    });
    
    $('.editors-pick .popular_posts_sec .post_with_image_and_title').each(function () {
        let slider = $(this).find(".post_list_inner");
        $(slider).slick({
            infinite: false,
            dots: false,
            arrows: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            responsive: [{
                    breakpoint: 1265,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: true,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: true,
                    }
                },
                {
                    breakpoint: 601,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        adaptiveHeight: true,
                        dots: true,
                    }
                },
            ]
        });
    });
    $("select").selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
    });


    $('.select_page_tab').on('change', function () {
        var categoryId = $(this).val();
        window.location.href = categoryId;
    });


    jQuery(".footer_right_sec .gform_wrapper .button.gform_button").detach().appendTo(".footer_right_sec .gform_wrapper .gform_body .gform_fields");
    jQuery(".footer_right_sec .gform_wrapper .gfield.wrap_field").wrapAll("<div class='inner_form_sec'></div>");

    let firstCodeRun = false;
    jQuery('.global_footer .footer_right_sec .gform_wrapper .checkbox_open_field input').click(function () {
        jQuery(this).parent().parent().parent().addClass('focus_input');
        let new_hide_sec = jQuery(this).parent().parent().parent().find(".inner_form_sec");
        if (jQuery(new_hide_sec).is(":hidden")) {
            jQuery(new_hide_sec).show();
            jQuery(new_hide_sec).addClass('active');
            setTimeout(function () {
                firstCodeRun = true;
            }, 200);
        }

    });

    if (jQuery(window).scrollTop() > 1) {
        jQuery(".fusion-tb-header").addClass("hide_notificaiton_bar");
    } else {
        jQuery(".fusion-tb-header").removeClass("hide_notificaiton_bar");
    }

    jQuery(document).click(function (event) {
        if (firstCodeRun && jQuery('.global_footer .footer_right_sec .gform_wrapper .inner_form_sec.active').is(":visible") && (jQuery(event.target).closest(".inner_form_sec").length == 0)) {
            jQuery('.global_footer .footer_right_sec .gform_wrapper .inner_form_sec').hide();
            jQuery('.global_footer .footer_right_sec .gform_wrapper .inner_form_sec').removeClass('active');
            firstCodeRun = false;
        }
    });



    var firstCheckbox = $(".global_footer .footer_right_sec .gform_wrapper .select_all_checkbox_field .gchoice:first input");
    var otherCheckboxes = $(".global_footer .footer_right_sec .gform_wrapper .select_all_checkbox_field  .gchoice:not(:first) input");
    var allCheckboxes = $(".global_footer .footer_right_sec .gform_wrapper .select_one_checkbox_field  .gchoice input");
    var allCheckboxes_b = $(".global_footer .footer_right_sec .gform_wrapper .select_all_checkbox_field  .gchoice input");


    function checkCheckboxState() {
        if ((allCheckboxes.filter(":checked").length > 0) && (allCheckboxes_b.filter(":checked").length > 0)) {
            $(".global_footer .footer_right_sec .gform_wrapper .custom_error_message").hide();
            $(".global_footer .footer_right_sec .gform_wrapper .checkbox_open_field").addClass("remove_error_space");
        } else {
            $(".global_footer .footer_right_sec .gform_wrapper .custom_error_message").show();
            $(".global_footer .footer_right_sec .gform_wrapper .checkbox_open_field").removeClass("remove_error_space");
        }
    }

    checkCheckboxState();

    allCheckboxes.click(function () {
        if (this.checked) {
            allCheckboxes.not(this).prop("checked", false);
        }
        checkCheckboxState();

    });

    firstCheckbox.click(function () {
        otherCheckboxes.prop("checked", this.checked);
        checkCheckboxState();
    });

    otherCheckboxes.click(function () {
        if (otherCheckboxes.length === otherCheckboxes.filter(":checked").length) {
            firstCheckbox.prop("checked", true);
        } else {
            firstCheckbox.prop("checked", false);
        }
        checkCheckboxState();
    });

    $(".global_footer .footer_right_sec .gform_wrapper .custom_btn").click(function () {
        $(".global_footer .footer_right_sec .gform_wrapper .gform_button").click();
    });

    $(".gfield.gfield_contains_required  input,.gfield.gfield_contains_required.gfield--type-email input,.gfield.gfield_contains_required textarea").keyup(function () {
        var inputValue = $(this).val();
        var inputType = $(this).attr("type");

        if (inputValue.length === 0) {
            if ($(this).parent(".gform-grid-col").length > 0) {
                let validationMessage = $(this).parent().find(".validation_message");
                if (validationMessage.length === 0) {
                    validationMessage = $("<div class='validation_message'></div>");
                    $(this).after(validationMessage);
                }
            } else {
                let validationMessage = $(this).closest(".gfield").find(".validation_message");
                if (validationMessage.length === 0) {
                    validationMessage = $("<div class='validation_message'></div>");
                    $(this).parent().after(validationMessage);
                }
            }
            if ($(this).parent(".gform-grid-col").length > 0) {
                $(this).parent(".gform-grid-col").addClass("gfield_error");
                $(this).next(".validation_message").text("This field is required.");
                $(this).parent(".gform-grid-col").find(".validation_message").show();
            } else {
                $(this).closest(".gfield").addClass("gfield_error");
                $(this).parent().next(".validation_message").text("This field is required.");
                $(this).parent().parent().find(".validation_message").show();
            }
        } else {
            if (inputType === "email") {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!emailRegex.test(inputValue)) {

                    if ($(this).parent(".gform-grid-col").length > 0) {
                        let validationMessage = $(this).parent().find(".validation_message");
                        if (validationMessage.length === 0) {
                            validationMessage = $("<div class='validation_message'></div>");
                            $(this).after(validationMessage);
                        }
                    } else {
                        let validationMessage = $(this).closest(".gfield").find(".validation_message");
                        if (validationMessage.length === 0) {
                            validationMessage = $("<div class='validation_message'></div>");
                            $(this).parent().after(validationMessage);
                        }
                    }

                    if ($(this).parent(".gform-grid-col").length > 0) {
                        $(this).parent(".gform-grid-col").addClass("gfield_error");
                        $(this).next(".validation_message").text("Must be a valid email address");
                        $(this).parent(".gform-grid-col").find(".validation_message").show();
                    } else {
                        $(this).closest('.gfield').addClass("gfield_error");
                        $(this).parent().next(".validation_message").text("Must be a valid email address");
                        $(this).parent().parent().find(".validation_message").show();
                    }
                } else {
                    if ($(this).parent(".gform-grid-col").length > 0) {
                        $(this).parent(".gform-grid-col").removeClass("gfield_error");
                        $(this).next(".validation_message").text("");
                        $(this).parent(".gform-grid-col").find(".validation_message").hide();
                    } else {
                        $(this).closest('.gfield').removeClass("gfield_error");
                        $(this).parent().next(".validation_message").text("");
                        $(this).parent().parent().find(".validation_message").hide();
                    }
                }
            } else {
                if ($(this).parent(".gform-grid-col").length > 0) {
                    $(this).parent(".gform-grid-col").removeClass("gfield_error");
                    $(this).next(".validation_message").text("");
                    $(this).parent(".gform-grid-col").find(".validation_message").hide();
                } else {
                    $(this).closest(".gfield").removeClass("gfield_error");
                    $(this).parent().next(".validation_message").text("");
                    $(this).parent().parent().find(".validation_message").hide();
                }
            }
        }
    });

    jQuery(document).on("click", ".fusion-body.single .single_header_social_share_column .header__nav-item .header__nav-link_clone", function () {
        var i = 0;
        jQuery(".main_header .header__nav-item--hamburger .header__nav-link").each(function () {
            i++;
            if (i == 1) {
                jQuery(this).click();
            }
        })
        jQuery(".fusion-tb-header").removeClass("hide_notificaiton_bar");
    })

    jQuery(document).on("click", "body:not(.media_cart_active, .show_asset_library) .main_header .header__nav-item--hamburger .header__nav-link", function () {
        if (jQuery("body").hasClass("mega_menu_active")) {
            jQuery(this).attr("aria-label", "Open navigation menu");
            jQuery(this).attr("aria-expanded", "false");
            jQuery("#desktop_mega_menu").attr("aria-hidden", "true");
            jQuery("body .site_custom_logo").removeClass("expand_logo");
            jQuery("body").removeClass("mega_menu_active");
            jQuery("#desktop_mega_menu .desktop_mega_menu .mega_menu_right_column").removeClass("animate animate2");
            jQuery("#desktop_mega_menu .desktop_mega_menu .mega_menu_right_column").removeClass("animate animate2");
            jQuery(this).find(".close_hamburger").hide();
            jQuery(this).find(".hamburger").show();
            setTimeout(function () {
                jQuery("#desktop_mega_menu").hide();
            }, 400);
            if (jQuery(".fusion-body.single-post").length > 0 && !jQuery(".fusion-tb-header").hasClass("hide_notificaiton_bar") && jQuery(window).scrollTop() > 1) {
                jQuery(".fusion-tb-header").addClass("hide_notificaiton_bar");
            }
        } else {
            jQuery("#desktop_mega_menu").show();
            jQuery(this).attr("aria-label", "Close navigation menu");
            jQuery(this).attr("aria-expanded", "true");
            jQuery("#desktop_mega_menu").attr("aria-hidden", "false");
            jQuery(this).find(".hamburger").hide();
            jQuery(this).find(".close_hamburger").show();
            jQuery("body").addClass("mega_menu_active");
            setTimeout(function () {
                jQuery("#desktop_mega_menu .desktop_mega_menu .mega_menu_right_column").addClass("animate");
                setTimeout(function () {
                    jQuery("#desktop_mega_menu .desktop_mega_menu .mega_menu_right_column").addClass("animate2");
                }, 600);
            }, 400);
            setTimeout(function () {
                jQuery("body .site_custom_logo").addClass("expand_logo");
            }, 100);
        }
    })

    jQuery(document).on("click", "body.media_cart_active .main_header .header__nav-item--hamburger .header__nav-link", function () {
        jQuery(".main_header .header__nav-item--cart .header__nav-link").parent().parent().addClass('media_cart_active');
        jQuery(".main_header .header__nav-item--cart .header__nav-link").attr("aria-label", "Open navigation menu");
        jQuery(".main_header .header__nav-item--cart .header__nav-link").attr("aria-expanded", "false");
        jQuery("#desktop_media_cart").attr("aria-hidden", "true");
        jQuery("body").removeClass("media_cart_active");
        jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").hide();
        jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").show();
        setTimeout(function () {
            jQuery("#desktop_media_cart").hide();
            jQuery(".main_header .header__nav-item--cart .header__nav-link").show();
            jQuery(".site_custom_logo").show();
        }, 400);
    });

    jQuery(document).on("click", "body.show_asset_library .main_header .header__nav-item--hamburger .header__nav-link", function () {
        jQuery("#desktop_assets_library").attr("aria-hidden", "true");
        jQuery("body").removeClass("show_asset_library");
        jQuery(".article-media-cart-sticky__item.asset").attr("aria-expanded", "false");
        jQuery(".article-media-cart-sticky__item.asset").attr("aria-label", "Open Asset Library");
        jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").hide();
        jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").show();
    });

    jQuery(document).on("click", ".main_header .header__nav-item--cart .header__nav-link", function () {
        if (jQuery("body").hasClass("media_cart_active")) {
            jQuery(this).parent().parent().addClass('media_cart_active');
            jQuery(this).attr("aria-label", "Open navigation menu");
            jQuery(this).attr("aria-expanded", "false");
            jQuery("#desktop_media_cart").attr("aria-hidden", "true");
            jQuery("body").removeClass("media_cart_active");
            jQuery(this).show();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").hide();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").show();
            jQuery(".cart_step_sec__inner__step_list").removeClass("fade_now");
            setTimeout(function () {
                jQuery("#desktop_media_cart").hide();
            }, 400);
        } else {
            jQuery("#desktop_media_cart").show();
            jQuery(this).attr("aria-label", "Close navigation menu");
            jQuery(this).attr("aria-expanded", "true");
            jQuery("#desktop_media_cart").attr("aria-hidden", "false");
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").hide();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").show();
            jQuery("body").addClass("media_cart_active");
            if (jQuery(".cart_step_sec__inner__step_list").hasClass("slick-initialized")) {
                jQuery(".cart_step_sec__inner__step_list").slick("refresh");
                if (jQuery(".fusion-body.cart_is_empty .media_cart_sec.empty_cart").is(":visible")) {
                    jQuery(".cart_step_sec__inner__step_list").addClass("fade_now");
                }
            }
            setTimeout(function () {
                jQuery(this).hide();
                jQuery(".site_custom_logo").hide();
            }, 400);
        }
    })

    jQuery(document).on("click", ".header__nav-item.header__nav-item--cart .secondary_header_cart_link", function () {
        if (jQuery("body").hasClass("media_cart_active")) {
            jQuery(this).parent().parent().addClass('media_cart_active');
            jQuery(this).attr("aria-label", "Open navigation menu");
            jQuery(this).attr("aria-expanded", "false");
            jQuery("#desktop_media_cart").attr("aria-hidden", "true");
            jQuery("body").removeClass("media_cart_active");
            jQuery(this).show();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").hide();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").show();
            jQuery(".cart_step_sec__inner__step_list").removeClass("fade_now");
            setTimeout(function () {
                jQuery("#desktop_media_cart").hide();
            }, 400);
        } else {
            jQuery("#desktop_media_cart").show();
            jQuery(this).attr("aria-label", "Close navigation menu");
            jQuery(this).attr("aria-expanded", "true");
            jQuery("#desktop_media_cart").attr("aria-hidden", "false");
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").hide();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").show();
            jQuery("body").addClass("media_cart_active");
            if (jQuery(".cart_step_sec__inner__step_list").hasClass("slick-initialized")) {
                jQuery(".cart_step_sec__inner__step_list").slick("refresh");
                if (jQuery(".fusion-body.cart_is_empty .media_cart_sec.empty_cart").is(":visible")) {
                    jQuery(".cart_step_sec__inner__step_list").addClass("fade_now");
                }
            }
            setTimeout(function () {
                jQuery(this).hide();
                jQuery(".site_custom_logo").hide();
            }, 400);
        }
    })

    jQuery(document).on("keydown", function (e) {
        if (e.keyCode == "27" && jQuery("body").hasClass("mega_menu_active")) {
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").attr("aria-label", "Open navigation menu");
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").attr("aria-expanded", "false");
            jQuery("#desktop_mega_menu").attr("aria-hidden", "true");
            jQuery("body .site_custom_logo").removeClass("expand_logo");
            jQuery("body").removeClass("mega_menu_active");
            jQuery("#desktop_mega_menu .desktop_mega_menu .mega_menu_right_column").removeClass("animate animate2");
            jQuery("#desktop_mega_menu .desktop_mega_menu .mega_menu_right_column").removeClass("animate animate2");
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").hide();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").show();
            setTimeout(function () {
                jQuery("#desktop_mega_menu").hide();
            }, 400);
        }
        if (e.keyCode == "27" && jQuery("body").hasClass("media_cart_active")) {
            jQuery(".main_header .header__nav-item--cart .header__nav-link").attr("aria-label", "Open navigation menu");
            jQuery(".main_header .header__nav-item--cart .header__nav-link").attr("aria-expanded", "false");
            jQuery("#desktop_media_cart").attr("aria-hidden", "true");
            jQuery(".main_header .header__nav-item--cart .header__nav-link").show();
            jQuery("body").removeClass("media_cart_active");
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".close_hamburger").hide();
            jQuery(".main_header .header__nav-item--hamburger .header__nav-link").find(".hamburger").show();
            setTimeout(function () {
                jQuery("#desktop_media_cart").hide();
            }, 400);
        }
    })

    var mainMenuHtml = jQuery(".fusion-layout-column.mega_menu_right_column nav.awb-menu.awb-menu_row #menu-main-menu")[0].outerHTML;
    mainMenuHtml = mainMenuHtml.replace("menu-main-menu", "menu-main-menu-mobile");
    jQuery(mainMenuHtml).insertAfter(jQuery("#desktop_mega_menu .fusion-layout-column.mega_menu_left_column .primary_search"));

    jQuery(document).on("click", "#menu-main-menu-mobile>.menu-item>a", function (e) {
        e.preventDefault();
        if (jQuery(this).parent().find(".awb-menu__sub-ul").is(":hidden")) {
            jQuery(this).parent().addClass("active");
            jQuery(this).parent().find(".awb-menu__sub-ul").slideDown();
        } else {
            jQuery(this).parent().removeClass("active");
            jQuery(this).parent().find(".awb-menu__sub-ul").slideUp();
        }
    })

    jQuery("input[type=submit].fusion-search-submit").attr("value", "Search");

    jQuery(".single_header_sticky_title, .single_header_social_share_column").wrapAll("<div class='custom-fusion-layout-column'></div>");

    jQuery(document).on("click", ".fusion-body.single .single_header_social_share_column .header__share-item .clickable", function () {
        if (jQuery(this).parent().find(".header__dropdown").is(":hidden")) {
            jQuery(this).parent().addClass("active");
            jQuery(this).parent().find(".header__dropdown").slideDown();
        } else {
            jQuery(this).parent().removeClass("active");
            jQuery(this).parent().find(".header__dropdown").slideUp();
        }
    })

    files_block();

    jQuery(window).scroll(function () {
        files_block();

        if (jQuery(window).scrollTop() > 1) {
            jQuery(".fusion-tb-header").addClass("hide_notificaiton_bar");
        } else {
            jQuery(".fusion-tb-header").removeClass("hide_notificaiton_bar");
        }
    });

    const divElements = document.querySelectorAll(".press_releases_post_sec .fusion-tb-published-date");

    divElements.forEach(function (divElement) {
        divElement.textContent = divElement.textContent.replace(/Published On: /g, "");
        divElement.classList.add("active");
    });

    $(".bio_title_sec h1.title-heading-left").each(function () {
        var html = $(this).html().split(" ");
        var strLength = html.length;
        if (strLength > 1) {
            html = html.slice(0, 1).join(" ") + "<br />" + html.slice(1).join(" ");
            $(this).html(html);
        }
    });

    jQuery(".csv_table_sec__inner__section_title__inner").on("click", function () {
        var $inner = jQuery(this).closest(".csv_table_sec__inner");
        var $csvFileSec = $inner.find(".csv_file_sec");
        if ($csvFileSec.is(":hidden")) {
            jQuery(this).addClass("active");
            $csvFileSec.slideDown(400, function () {
                initVisibleCsvDataTables($csvFileSec[0]);
            });
        } else {
            jQuery(this).removeClass("active");
            $csvFileSec.slideUp();
        }
    })

    jQuery(document).on('click', ".email_cart_trigger", function () {
        jQuery("body").toggleClass("model_active");
        jQuery(".media_cart_modal__inner .media_cart_form__btn").removeClass("clicked");
        jQuery('.media_cart_modal.email_cart_modal').toggleClass('model_visible');
    });
    jQuery(document).on('click', ".download_cart_trigger", function () {
        jQuery("body").toggleClass("model_active");
        jQuery(".media_cart_modal__inner .media_cart_form__btn").removeClass("clicked");
        var assetsCount = 0;
        if (jQuery("body").hasClass("media_cart_active")) {
            var cartItems = localStorage.getItem("cart_items");
            if (cartItems != "" && cartItems != "undefined" && cartItems != null) {
                cartItems = JSON.parse(cartItems);
                assetsCount = cartItems.length;
            }
            jQuery("body").removeClass("asset_lib_selected_media_enabled");
        } else if (jQuery("body").hasClass("single-media-tool")) {
            var cartItems = window.downloadable_assets;
            assetsCount = jQuery(".single-media-tool .media-tools-row input[type=checkbox]:checked").length;
            jQuery("body").addClass("asset_lib_selected_media_enabled");
        } else {
            var cartItems = window.downloadable_assets;
            if (jQuery(this).hasClass("selected_btn")) {
                assetsCount = jQuery(".media-cart.media-cart--asset_library input[type=checkbox]:checked").length;
                jQuery("body").addClass("asset_lib_selected_media_enabled");
            } else {
                if (cartItems != "" && cartItems != "undefined" && cartItems != null) {
                    assetsCount = Object.keys(window.downloadable_assets).length;
                }
                jQuery("body").removeClass("asset_lib_selected_media_enabled");
            }
        }
        jQuery("#assets_count").text(assetsCount ? assetsCount : "all");
        jQuery('.media_cart_modal.download_cart_model').toggleClass('model_visible');
    });
    jQuery(document).on('click', ".add_to_cart_trigger:not(.email_sent_model)", function () {
        // jQuery("body").toggleClass("model_active");
        jQuery('.add_to_cart_modal:not(.email_sent_model)').addClass('model_visible');
        setTimeout(function () {
            // jQuery("body").removeClass("model_active");
            jQuery('.add_to_cart_modal:not(.email_sent_model)').removeClass("model_visible");
        }, 2000);
    });
    jQuery(document).on('click', ".empty_cart_trigger", function () {
        localStorage.setItem("cart_items", "");
        jQuery("#cart_all_count").text("(0)");
        jQuery("#image_all_count").text("(0)");
        jQuery("#document_all_count").text("(0)");
        if (jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").length > 0) {
            jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").removeClass("show");
        }
        if (jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").length > 0) {
            jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").removeClass("show");
        }
        jQuery("body").addClass("cart_is_empty");
        jQuery(".cart_step_sec__inner__step_list").slick("refresh");
        jQuery(".cart_step_sec__inner__step_list").addClass("fade_now");
        jQuery('.media_cart_sec.with_cart_item').fadeOut();
        setTimeout(function () {
            jQuery('.media_cart_sec.empty_cart').fadeIn();
        }, 300);
    });


    if (jQuery('.media_cart_sec').length > 0) {
        jQuery('#tab-1').addClass('current');
        jQuery(document).on('click', '.media_cart_sec .tabs .tab_link', function () {
            var tab_id = jQuery(this).attr('data-tab');

            jQuery('.media_cart_sec .tabs .tab_link').removeClass('current');
            // jQuery('.media_cart_sec .tab_content').removeClass('current');

            jQuery(this).addClass('current');
            if (tab_id != "all") {
                jQuery('#cart_item_list_main .cart_item_list__item').hide();
                jQuery('#cart_item_list_main .cart_item_list__item.item_' + tab_id).show();
            } else {
                jQuery('#cart_item_list_main .cart_item_list__item').show();
            }
        });
    }

    jQuery(document).on("click", ".media_item_action_hover__btn.delete_btn", function () {
        if (jQuery(this).closest(".cart_item_list__item").length > 0) {
            var assetId = jQuery(this).closest(".cart_item_list__item").attr("data-id");
            var cartItems = localStorage.getItem("cart_items");
            if (cartItems != "" && cartItems != "undefined" && cartItems != null) {
                cartItems = JSON.parse(cartItems);

                for (let item in cartItems) {
                    var currentItem = cartItems[item];
                    if (currentItem != undefined && currentItem.id != undefined && currentItem.id == assetId) {
                        if (item > -1) { // only splice array when item is found
                            cartItems.splice(item, 1); // 2nd parameter means remove one item only
                            localStorage.setItem("cart_items", JSON.stringify(cartItems));
                            setCount(cartItems);
                        }
                    }
                }

                imageCount = 0;
                documentCount = 0;
                for (let item in cartItems) {
                    var currentItem = cartItems[item];
                    if (currentItem != undefined && currentItem.type != undefined && currentItem.type == "image") {
                        imageCount++;
                    }
                    if (currentItem != undefined && currentItem.type != undefined && currentItem.type == "document") {
                        documentCount++;
                    }
                }
                jQuery("#cart_all_count").text("(" + (imageCount + documentCount) + ")");
                jQuery("#image_all_count").text("(" + imageCount + ")");
                jQuery("#document_all_count").text("(" + documentCount + ")");
            }
            jQuery(this).closest(".cart_item_list__item").remove();
        }
        if (!jQuery(".media_cart_sec .cart_item_list__item").length) {
            jQuery(".empty_cart_trigger").trigger('click');
        }
    })



    var emailcartfrm = jQuery('#EmailCart');
    emailcartfrm.on("click", function (e) {
        e.preventDefault();
        var toEmail = jQuery('#email-to-email').val();
        var senderEmail = jQuery('#email-sender-email').val();
        if ((toEmail != "" && toEmail != undefined && toEmail != null) || (senderEmail != "" && senderEmail != undefined && senderEmail != null)) {
            if (toEmail != "" && toEmail != undefined && toEmail != null && !validateEmail(toEmail)) {
                if (jQuery(".media_cart_form__wrap.recipient_field .validation-message").length > 0) {
                    jQuery(".media_cart_form__wrap.recipient_field .validation-message").remove();
                }
                jQuery("<span class='validation-message'>Please enter a valid email address.</span>").insertAfter(jQuery('#email-to-email'));
                return false;
            }
            if (senderEmail != "" && senderEmail != undefined && senderEmail != null && !validateEmail(senderEmail)) {
                if (jQuery(".media_cart_form__wrap.your_email_field .validation-message").length > 0) {
                    jQuery(".media_cart_form__wrap.your_email_field .validation-message").remove();
                }
                jQuery("<span class='validation-message'>Please enter a valid email address.</span>").insertAfter(jQuery('#email-sender-email'));
                return false;
            }
            jQuery(".media_cart_modal__inner .media_cart_form__btn").addClass("clicked");
            var cartItems = localStorage.getItem("cart_items");
            var formData = {
                to: toEmail,
                sender: senderEmail,
                files: cartItems,
                action: 'email_cart_mail'
            };
            jQuery.ajax({
                url: window.admin_aurl,
                data: formData, // form data
                type: "POST", // POST
                async: true,
                beforeSend: function (xhr) {
                    console.log("ajax start"); // changing the button label
                },
                success: function (data) {
                    console.info(data);
                    if (data.success) {
                        jQuery('.media_cart_modal.email_cart_modal').removeClass('model_visible');
                        jQuery('.email_sent_model').addClass('model_visible');
                        setTimeout(function () {
                            jQuery('.email_sent_model').removeClass("model_visible");
                        }, 2000);
                    }
                },
                error: function (xhr) {
                    jQuery(".blog_listing_items .blog_listing_items_inner").show();
                    console.log(xhr);
                }
            });
        } else {
            if (jQuery(".media_cart_form__wrap .validation-message").length > 0) {
                jQuery(".media_cart_form__wrap .validation-message").remove();
            }
            if (jQuery('#email-to-email').length > 0) {
                jQuery("<span class='validation-message'>This field is required.</span>").insertAfter(jQuery('#email-to-email'));
            }
            if (jQuery('#email-sender-email').length > 0) {
                jQuery("<span class='validation-message'>This field is required.</span>").insertAfter(jQuery('#email-sender-email'));
            }
        }
        e.preventDefault();
    });

    var downloadAll = jQuery('#downloadAll');
    downloadAll.on("click", function (e) {
        e.preventDefault();
        var toEmail = jQuery('#download-to-email').val();
        if (toEmail != "" && toEmail != undefined && toEmail != null) {
            if (jQuery(".media_cart_form__wrap .validation-message").length > 0) {
                jQuery(".media_cart_form__wrap .validation-message").remove();
            }
            if (!validateEmail(toEmail)) {
                jQuery("<span class='validation-message'>Please enter a valid email address.</span>").insertAfter(jQuery('#download-to-email'));
                return false;
            }

            jQuery(".media_cart_modal__inner .media_cart_form__btn").addClass("clicked");
            if (jQuery("body").hasClass("media_cart_active")) {
                var cartItems = localStorage.getItem("cart_items");
            } else if (jQuery("body").hasClass("single-media-tool")) {
                if (jQuery("body").hasClass("asset_lib_selected_media_enabled")) {
                    var cartItemsObj = [];
                    jQuery(".single-media-tool .media-tools-row input[type=checkbox]:checked").each(function () {
                        var assetId = jQuery(this).attr("data-id");
                        var assetObject = null;
                        if (window.downloadable_assets != undefined && window.downloadable_assets != null && window.downloadable_assets != "undefined" && window.downloadable_assets[assetId] != undefined) {
                            assetObject = window.downloadable_assets[assetId];
                            cartItemsObj.push(assetObject);
                        }
                    })
                    var cartItems = JSON.stringify(cartItemsObj);
                }
            } else {
                if (jQuery("body").hasClass("asset_lib_selected_media_enabled")) {
                    var cartItemsObj = [];
                    jQuery(".media-cart.media-cart--asset_library input[type=checkbox]:checked").each(function () {
                        var assetId = jQuery(this).attr("data-id");
                        var assetObject = null;
                        if (window.downloadable_assets != undefined && window.downloadable_assets != null && window.downloadable_assets != "undefined" && window.downloadable_assets[assetId] != undefined) {
                            assetObject = window.downloadable_assets[assetId];
                            cartItemsObj.push(assetObject);
                        }
                    })
                    var cartItems = JSON.stringify(cartItemsObj);
                } else {
                    let jsonData;

                    if (typeof window.downloadable_assets === "string") {
                        // If it's a string, replace single quotes with double quotes
                        jsonData = JSON.parse(window.downloadable_assets.replace(/'/g, '"'));
                    } else if (typeof window.downloadable_assets === "object" && window.downloadable_assets !== null) {
                        // If it's already an object, no need to parse
                        jsonData = window.downloadable_assets;
                    } else {
                        console.error("window.downloadable_assets is undefined or not in a valid format.");
                    }
                    var cartItems = jsonData;
                }
            }
            var formData = {
                to: toEmail,
                files: cartItems,
                action: 'download_all_mail'
            };
            if(cartItems){
                jQuery.ajax({
                    url: window.admin_aurl,
                    data: formData, // form data
                    type: "POST", // POST
                    async: true,
                    beforeSend: function (xhr) {
                        console.log("ajax start"); // changing the button label
                    },
                    success: function (data) {
                        console.info(data);
                        if (data.success) {
                            jQuery('.media_cart_modal.download_cart_model').removeClass('model_visible');
                            jQuery('.email_sent_model').addClass('model_visible');
                            setTimeout(function () {
                                jQuery('.email_sent_model').removeClass("model_visible");
                            }, 2000);
                        }
                    },
                    error: function (xhr) {
                        jQuery(".blog_listing_items .blog_listing_items_inner").show();
                        console.log(xhr);
                    }
                });
            }else {
                if (jQuery('#download-to-email').length > 0) {
                    if (jQuery(".media_cart_form__wrap .validation-message").length > 0) {
                        jQuery(".media_cart_form__wrap .validation-message").remove();
                    }
    
                    jQuery("<span class='validation-message'>Missing all downloadable items.</span>").insertAfter(jQuery('#download-to-email'));
                }
            }
        } else {
            if (jQuery('#download-to-email').length > 0) {
                if (jQuery(".media_cart_form__wrap .validation-message").length > 0) {
                    jQuery(".media_cart_form__wrap .validation-message").remove();
                }

                jQuery("<span class='validation-message'>This field is required.</span>").insertAfter(jQuery('#download-to-email'));
            }
        }
    });

    onScrollEvents();
    onResizeEvents();


    $(".article-slide__action").click(function () {
        $(this).parent().parent().parent().addClass("slide-popup-active");
        jQuery("body").addClass("slideshow_open");
        if ($(this).parent().parent().parent().find(".slide-popup .slick-slide.slick-current .story__figure-content").length > 0) {
            var captionVal = $(this).parent().parent().parent().find(".slide-popup .slick-slide.slick-current .story__figure-content").attr("data-caption");
            if (captionVal != undefined && captionVal != null && captionVal != "") {
                $(this).parent().parent().parent().find(".slide-popup .slide-popup__description").removeClass("show");
                $(this).parent().parent().parent().find(".slide-popup .slide-popup__description").text(captionVal);
                $(this).parent().parent().parent().find(".slide-popup .slide-popup__description").addClass("show");
            } else {
                $(this).parent().parent().parent().find(".slide-popup .slide-popup__description").removeClass("show");
                setTimeout(function () {
                    $(this).parent().parent().parent().find(".slide-popup .slide-popup__description").text("");
                }, 500);
            }
        }
    });

    $(".slide-popup__header").click(function () {
        $(this).parent().parent().parent().parent().removeClass("slide-popup-active");
        jQuery("body").removeClass("slideshow_open");
    });

    $(".slide-popup__view-all").click(function () {
        $(this).parent().parent().parent().parent().parent().parent().addClass("thumb-popup-active");
    });

    $(".thumb-popup__close").click(function () {
        $(this).parent().parent().parent().removeClass("thumb-popup-active");
    });


    jQuery(".article-slideshow").each(function (index) {
        let slide = jQuery(this).find('.slide-popup__figure');
        let slider = jQuery(this).find('.slide-popup__mainslider');
        let sliderPrev = jQuery(this).find('.slide-popup__control .slide-popup__control_prev');
        let sliderNext = jQuery(this).find('.slide-popup__control .slide-popup__control_next');
        let sliderNav = jQuery(this).find('.slide-popup__thumbslider');
        let count = jQuery(slider).parent().parent().parent().find('.slide-popup__page');
        if (jQuery(slide).length > 1) {
            var currentSlide;
            var slidesCount;
            var sliderCounter = count.append('<div class="slide-popup__page__count"></div>');

            var updateSliderCounter = function (slick, currentIndex) {
                currentSlide = slick.slickCurrentSlide() + 1;
                slidesCount = slick.slideCount.toString().padStart(2, '0');
                $(sliderCounter).html('<span class="current">' + currentSlide.toString().padStart(2, '0') + '</span>' + '/' + slidesCount);
            };

            slider.on('init', function (event, slick) {
                updateSliderCounter(slick);
            });

            slider.on('afterChange', function (event, slick, currentSlide) {
                var activeSlideCaption = jQuery(this).find(".slick-slide.slick-current .story__figure-content").attr("data-caption");
                if (activeSlideCaption != undefined && activeSlideCaption != null && activeSlideCaption != "") {
                    $(this).closest(".slide-popup__left").parent().find(".slide-popup__description").removeClass("show");
                    $(this).closest(".slide-popup__left").parent().find(".slide-popup__description").text(activeSlideCaption);
                    $(this).closest(".slide-popup__left").parent().find(".slide-popup__description").addClass("show");
                } else {
                    $(this).closest(".slide-popup__left").parent().find(".slide-popup__description").removeClass("show");
                    setTimeout(function () {
                        $(this).closest(".slide-popup__left").parent().find(".slide-popup__description").text("");
                    }, 500);
                }
                updateSliderCounter(slick, currentSlide);
            });

            slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                prevArrow: sliderPrev,
                nextArrow: sliderNext,
                fade: true,
                asNavFor: sliderNav,
                infinite: false,
            });

            sliderNav.slick({
                slidesToShow: 12,
                slidesToScroll: 1,
                asNavFor: slider,
                dots: true,
                variableWidth: false,
                infinite: false,
                arrows: false,
                focusOnSelect: true,
                responsive: [{
                        breakpoint: 1360,
                        settings: {
                            slidesToShow: 6
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 4
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2
                        }
                    }
                ]
            });
        }
    });

    initVisibleCsvDataTables();

    jQuery(".article-list-table  .pagination__content .pagination__item").on("click", function () {
        var num1 = jQuery(this).text().trim();
        jQuery(this).closest(".article-list-table__wrap").find(".list-body .list-body__item").hide();
        jQuery(this).closest(".article-list-table__wrap").find(".list-body .list-body__item.block_" + num1).show();
        jQuery(this).siblings().removeClass("active");
        jQuery(this).addClass("active");
    })
    jQuery(".article-list-table .article-list-table__pagination .pagination__prev").on("click", function () {
        var activeIndex = jQuery(this).closest(".article-list-table__pagination").find(".pagination__content .pagination__item.active").index();
        if ((activeIndex + 1) > 1) {
            jQuery(this).closest(".article-list-table__pagination").find(".pagination__content .pagination__item.active").prev().click();
        }
    });
    jQuery(".article-list-table .article-list-table__pagination .pagination__next").on("click", function () {
        var totalLength = jQuery(this).closest(".article-list-table__pagination").find(".pagination__content .pagination__item").length;
        var activeIndex = jQuery(this).closest(".article-list-table__pagination").find(".pagination__content .pagination__item.active").index();
        if ((activeIndex + 1) < totalLength) {
            jQuery(this).closest(".article-list-table__pagination").find(".pagination__content .pagination__item.active").next().click();
        }
    });

    jQuery(".article-list-table .article-list-table__inner .ccollapse__head").on("click", function () {
        if (jQuery(this).parent().find(".ccollapse__content").is(":hidden")) {
            jQuery(this).parent().find(".ccollapse__content").slideDown();
            jQuery(this).parent().addClass("active");
        } else {
            jQuery(this).parent().find(".ccollapse__content").slideUp();
            jQuery(this).parent().removeClass("active");
        }
    });

    if (jQuery(".press_releases_sec__inner__list__loadmore .loadMore").length > 0) {
        jQuery(".press_releases_sec__inner__list__loadmore .loadMore").on("click", function () {
            filterPress("loadmore");
        });
    }

    if (jQuery(".topic_post_list_custom .load-more__btn").length > 0) {
        jQuery(".topic_post_list_custom .load-more__btn").on("click", function () {
            filterTopicPosts("loadmore");
        });
    }
    
    if (jQuery(".topic_post_list_custom .search-load-more__btn").length > 0) {
        jQuery(".topic_post_list_custom .search-load-more__btn").on("click", function () {
            LoadMoreSearchResult("loadmore");
        });
    }

    if (jQuery(".article-media-cart-sticky__item.asset").length > 0) {
        jQuery(".article-media-cart-sticky__item.asset").on("click", function () {
            jQuery("body").addClass("show_asset_library");
            jQuery(this).attr("aria-expanded", "true");
            jQuery(this).attr("aria-label", "Close Asset Library");
        })
    }

    if (jQuery(".media-item--media_tools").length > 0) {
        jQuery(".media-item.media-item--media_tools").on("click", function () {
            if (!jQuery(this).hasClass("media-item__btn") && jQuery(this).closest(".media-item__btn").length == 0 && jQuery(this).closest(".media-item").find("input[type=checkbox]").length > 0) {
                if (jQuery(this).closest(".media-item").find("input[type=checkbox]").is(":checked")) {
                    jQuery(this).closest(".media-item").find("input[type=checkbox]").prop("checked", false);
                } else {
                    jQuery(this).closest(".media-item").find("input[type=checkbox]").prop("checked", true);
                }
            }
            checkCheckboxMediaTools();
        })
    }

    if (jQuery(".media-item--asset_library").length > 0) {
        jQuery(".media-item.media-item--asset_library").on("click", function () {
            if (!jQuery(this).hasClass("media-item__btn") && jQuery(this).closest(".media-item__btn").length == 0 && jQuery(this).closest(".media-item").find("input[type=checkbox]").length > 0) {
                if (jQuery(this).closest(".media-item").find("input[type=checkbox]").is(":checked")) {
                    jQuery(this).closest(".media-item").find("input[type=checkbox]").prop("checked", false);
                } else {
                    jQuery(this).closest(".media-item").find("input[type=checkbox]").prop("checked", true);
                }

                checkbox_check(".media-item.media-item--asset_library");
            }
        })
    }

    if (jQuery(".media-cart.media-cart--media_tools .select_all_check").length > 0) {
        jQuery(".media-cart.media-cart--media_tools .select_all_check").on("click", function () {
            jQuery(this).closest(".media_tool_type_sec").find("input[type=checkbox]").prop("checked", true);
            checkCheckboxMediaTools();
        })
    }

    if (jQuery(".media-cart.media-cart--media_tools .deselect_all_check").length > 0) {
        jQuery(".media-cart.media-cart--media_tools .deselect_all_check").on("click", function () {
            jQuery(this).closest(".media_tool_type_sec").find("input[type=checkbox]").prop("checked", false);
            checkCheckboxMediaTools();
        })
    }

    if (jQuery(".media-cart.media-cart--asset_library .select_all_check").length > 0) {
        jQuery(".media-cart.media-cart--asset_library .select_all_check").on("click", function () {
            jQuery(this).closest(".media-cart__content").find("input[type=checkbox]").prop("checked", true);
            checkbox_check(".media-item.media-item--asset_library");
        })
    }

    if (jQuery(".media-cart.media-cart--asset_library .deselect_all_check").length > 0) {
        jQuery(".media-cart.media-cart--asset_library .deselect_all_check").on("click", function () {
            jQuery(this).closest(".media-cart__content").find("input[type=checkbox]").prop("checked", false);
            checkbox_check(".media-item.media-item--asset_library");
        })
    }

    if (jQuery(".media-item.media-item--asset_library .add_to_cart_trigger").length > 0) {
        jQuery(".media-item.media-item--asset_library .add_to_cart_trigger").on("click", function () {
            var assetId = jQuery(this).attr("data-id");
            var assetObject = null;
            if (window.downloadable_assets != undefined && window.downloadable_assets != null && window.downloadable_assets != "undefined" && window.downloadable_assets[assetId] != undefined) {
                assetObject = window.downloadable_assets[assetId];
                setSingleItemToCart(assetObject);
            }
        })
    }

    if (jQuery(".media-cart.media-cart--media_tools .add_to_cart_trigger").length > 0) {
        jQuery(".media-cart.media-cart--media_tools .add_to_cart_trigger").on("click", function () {
            var assetId = jQuery(this).attr("data-id");
            var assetObject = null;
            if (window.downloadable_assets != undefined && window.downloadable_assets != null && window.downloadable_assets != "undefined" && window.downloadable_assets[assetId] != undefined) {
                assetObject = window.downloadable_assets[assetId];
                setSingleItemToCart(assetObject);
            }
        })
    }


    if (jQuery(".media-cart--asset_library .media-cart__items-controls-btn").length > 0) {
        jQuery(".media-cart--asset_library .media-cart__items-controls-btn").on("click", function () {
            if (jQuery(this).hasClass("selected_btn")) {
                jQuery(".media-item.media-item--asset_library input[type=checkbox]:checked").each(function () {
                    var assetId = jQuery(this).attr("data-id");
                    var assetObject = null;
                    if (window.downloadable_assets != undefined && window.downloadable_assets != null && window.downloadable_assets != "undefined" && window.downloadable_assets[assetId] != undefined) {
                        assetObject = window.downloadable_assets[assetId];
                        setSingleItemToCart(assetObject);
                    }
                })
            } else {
                jQuery(".media-item.media-item--asset_library input[type=checkbox]").each(function () {
                    var assetId = jQuery(this).attr("data-id");
                    var assetObject = null;
                    if (window.downloadable_assets != undefined && window.downloadable_assets != null && window.downloadable_assets != "undefined" && window.downloadable_assets[assetId] != undefined) {
                        assetObject = window.downloadable_assets[assetId];
                        setSingleItemToCart(assetObject);
                    }
                })
            }
            jQuery('.add_to_cart_modal:not(.email_sent_model)').addClass('model_visible');
            setTimeout(function () {
                jQuery('.add_to_cart_modal:not(.email_sent_model)').removeClass("model_visible");
            }, 2000);
        })
    }

    if (jQuery(".media-tool-page__cart .media-tool-cart__btn--cart").length > 0) {
        jQuery(".media-tool-page__cart .media-tool-cart__btn--cart").on("click", function () {
            jQuery(".single-media-tool .media-tools-row input[type=checkbox]:checked").each(function () {
                var assetId = jQuery(this).attr("data-id");
                var assetObject = null;
                if (window.downloadable_assets != undefined && window.downloadable_assets != null && window.downloadable_assets != "undefined" && window.downloadable_assets[assetId] != undefined) {
                    assetObject = window.downloadable_assets[assetId];
                    setSingleItemToCart(assetObject);
                }
            })

            jQuery('.add_to_cart_modal:not(.email_sent_model)').addClass('model_visible');
            setTimeout(function () {
                jQuery('.add_to_cart_modal:not(.email_sent_model)').removeClass("model_visible");
            }, 2000);
        })
    }

    mediaToolsStickyBar();
    offsetLeft();

    if (jQuery(".custom_post_feature_image").length > 0) {
        var image1 = jQuery(".custom_post_feature_image").attr("data-image");
        if (image1 != undefined && image1 != "" && image1 != null) {
            const urlObj = new URL(image1);
            urlObj.search = '';
            const result = urlObj.toString();
            jQuery(".custom_post_feature_image .custom_post_feature_image_inner").css("background-image", "url(" + result + ")");
        }
    }

    if (jQuery("input[type=hidden][name='fs']").length > 0) {
        jQuery("input[type=hidden][name='fs']").remove();
    }
    if (jQuery(".single-post .post-hero .vertical_text.post-hero-category").length > 0) {
        var catText = jQuery(".post-hero .vertical_text.post-hero-category").text();
        if (catText != undefined && catText != null && catText != "") {
            catText = catText.trim().toLowerCase();
            if (catText == "uncategorized") {
                jQuery(".post-hero .vertical_text.post-hero-category").text("");
            }
        }
        jQuery(".post-hero .vertical_text.post-hero-category").addClass("show");
    }

    if (jQuery(".article-slideshow .article-slide__image").length > 0) {
        jQuery(".article-slideshow .article-slide__image").each(function () {
            var dataImage = jQuery(this).attr("data-image");
            if (dataImage != undefined && dataImage != "" && dataImage != null) {
                const urlObj = new URL(dataImage);
                urlObj.search = '';
                const dresult = urlObj.toString();
                jQuery(this).css("background-image", "url(" + dresult + ")");
            }
        })
    }
    
    if (jQuery(".article-slideshow .slide-popup .story__figure img").length > 0) {
        jQuery(".article-slideshow .slide-popup .story__figure img").each(function () {
            var dataImage2 = jQuery(this).attr("data-src");
            if (dataImage2 != undefined && dataImage2 != "" && dataImage2 != null) {
                const urlObj = new URL(dataImage2);
                urlObj.search = '';
                const dresult2 = urlObj.toString();
                jQuery(this).attr("src", dresult2);
            }
        })
    }
    
    if (jQuery(".custom_image_carousel_sec_inner .card_slider_item .image img").length > 0) {
        jQuery(".custom_image_carousel_sec_inner .card_slider_item .image img").each(function () {
            var dataImage3 = jQuery(this).attr("data-src");
            if (dataImage3 != undefined && dataImage3 != "" && dataImage3 != null) {
                const urlObj = new URL(dataImage3);
                urlObj.search = '';
                const dresult3 = urlObj.toString();
                jQuery(this).attr("src", dresult3);
            }
        })
    }

    jQuery('a[target="_blank"]').each(function() {
        jQuery(this).append('<span class="sr-only">(opens in a new tab)</span>');
    });

    jQuery('img:not([alt])').each(function() {
        jQuery(this).attr('alt', 'REMAX');
    });

    jQuery('.iframe-block .fusion-column-wrapper > iframe').parent().addClass('iframe-wrapper');

});

function checkbox_check(items) {
    if (jQuery(items).find("input[type=checkbox]:checked").length > 0) {
        jQuery(".media-cart__items-controls-btn.selected_btn").removeAttr("disabled");
        jQuery(".media-cart__btn.selected_btn").removeAttr("disabled");
    } else {
        jQuery(".media-cart__items-controls-btn.selected_btn").prop("disabled", "disabled");
        jQuery(".media-cart__btn.selected_btn").prop("disabled", "disabled");
    }
}

function files_block() {
    if (jQuery('.files_block_section').length > 0) {
        jQuery('.files_block_section').each(function () {
            if ((jQuery(window).scrollTop() + (jQuery(window).height() * 0.8)) > jQuery(this).offset().top) {
                jQuery(this).addClass("visible");
                var element = this;
                setTimeout(function () {
                    jQuery(element).addClass("text_visible");
                }, 500);
            }
        })
    }
}

jQuery(document).on('gform_page_loaded', function (event, form_id, current_page) {
    jQuery("select").selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
    });
    jQuery(".footer_right_sec .gform_wrapper .button.gform_button").detach().appendTo(".footer_right_sec .gform_wrapper .gform_body .gform_fields");
    jQuery(".footer_right_sec .gform_wrapper .gfield.wrap_field").wrapAll("<div class='inner_form_sec'></div>");

    let firstCodeRun = false;
    jQuery('.global_footer .footer_right_sec .gform_wrapper .checkbox_open_field input').click(function () {
        jQuery(this).parent().parent().parent().addClass('focus_input');
        let new_hide_sec = jQuery(this).parent().parent().parent().find(".inner_form_sec");
        if (jQuery(new_hide_sec).is(":hidden")) {
            jQuery(new_hide_sec).show();
            jQuery(new_hide_sec).addClass('active');
            setTimeout(function () {
                firstCodeRun = true;
            }, 200);
        }

    });

    jQuery(document).click(function (event) {
        if (firstCodeRun && jQuery('.global_footer .footer_right_sec .gform_wrapper .inner_form_sec.active').is(":visible") && (jQuery(event.target).closest(".inner_form_sec").length == 0)) {
            jQuery('.global_footer .footer_right_sec .gform_wrapper .inner_form_sec').hide();
            jQuery('.global_footer .footer_right_sec .gform_wrapper .inner_form_sec').removeClass('active');
            firstCodeRun = false;
        }
    });

    var firstCheckbox = jQuery(".global_footer .footer_right_sec .gform_wrapper .select_all_checkbox_field .gchoice:first input");
    var otherCheckboxes = jQuery(".global_footer .footer_right_sec .gform_wrapper .select_all_checkbox_field  .gchoice:not(:first) input");
    var allCheckboxes = jQuery(".global_footer .footer_right_sec .gform_wrapper .select_one_checkbox_field  .gchoice input");
    var allCheckboxes_b = jQuery(".global_footer .footer_right_sec .gform_wrapper .select_all_checkbox_field  .gchoice input");

    function checkCheckboxState() {
        if ((allCheckboxes.filter(":checked").length > 0) && (allCheckboxes_b.filter(":checked").length > 0)) {
            jQuery(".global_footer .footer_right_sec .gform_wrapper .custom_error_message").hide();
            jQuery(".global_footer .footer_right_sec .gform_wrapper .checkbox_open_field").addClass("remove_error_space");
        } else {
            jQuery(".global_footer .footer_right_sec .gform_wrapper .custom_error_message").show();
            jQuery(".global_footer .footer_right_sec .gform_wrapper .checkbox_open_field").removeClass("remove_error_space");
        }
    }

    checkCheckboxState();

    allCheckboxes.click(function () {
        if (this.checked) {
            allCheckboxes.not(this).prop("checked", false);
        }
        checkCheckboxState();

    });

    firstCheckbox.click(function () {
        otherCheckboxes.prop("checked", this.checked);
        checkCheckboxState();
    });

    otherCheckboxes.click(function () {
        if (otherCheckboxes.length === otherCheckboxes.filter(":checked").length) {
            firstCheckbox.prop("checked", true);
        } else {
            firstCheckbox.prop("checked", false);
        }
        checkCheckboxState();
    });

    jQuery(".global_footer .footer_right_sec .gform_wrapper .custom_btn").click(function () {
        jQuery(".global_footer .footer_right_sec .gform_wrapper .gform_button").click();
    });

    jQuery(".gfield.gfield_contains_required  input,.gfield.gfield_contains_required.gfield--type-email input,.gfield.gfield_contains_required textarea").keyup(function () {
        var inputValue = jQuery(this).val();
        var inputType = jQuery(this).attr("type");

        if (inputValue.length === 0) {
            if (jQuery(this).parent(".gform-grid-col").length > 0) {
                let validationMessage = jQuery(this).parent().find(".validation_message");
                if (validationMessage.length === 0) {
                    validationMessage = jQuery("<div class='validation_message'></div>");
                    jQuery(this).after(validationMessage);
                }
            } else {
                let validationMessage = jQuery(this).closest(".gfield").find(".validation_message");
                if (validationMessage.length === 0) {
                    validationMessage = jQuery("<div class='validation_message'></div>");
                    jQuery(this).parent().after(validationMessage);
                }
            }
            if (jQuery(this).parent(".gform-grid-col").length > 0) {
                jQuery(this).parent(".gform-grid-col").addClass("gfield_error");
                jQuery(this).next(".validation_message").text("This field is required.");
                jQuery(this).parent(".gform-grid-col").find(".validation_message").show();
            } else {
                jQuery(this).closest(".gfield").addClass("gfield_error");
                jQuery(this).parent().next(".validation_message").text("This field is required.");
                jQuery(this).parent().parent().find(".validation_message").show();
            }
        } else {
            if (inputType === "email") {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
                if (!emailRegex.test(inputValue)) {

                    if (jQuery(this).parent(".gform-grid-col").length > 0) {
                        let validationMessage = jQuery(this).parent().find(".validation_message");
                        if (validationMessage.length === 0) {
                            validationMessage = jQuery("<div class='validation_message'></div>");
                            jQuery(this).after(validationMessage);
                        }
                    } else {
                        let validationMessage = jQuery(this).closest(".gfield").find(".validation_message");
                        if (validationMessage.length === 0) {
                            validationMessage = jQuery("<div class='validation_message'></div>");
                            jQuery(this).parent().after(validationMessage);
                        }
                    }

                    if (jQuery(this).parent(".gform-grid-col").length > 0) {
                        jQuery(this).parent(".gform-grid-col").addClass("gfield_error");
                        jQuery(this).next(".validation_message").text("Must be a valid email address");
                        jQuery(this).parent(".gform-grid-col").find(".validation_message").show();
                    } else {
                        jQuery(this).closest('.gfield').addClass("gfield_error");
                        jQuery(this).parent().next(".validation_message").text("Must be a valid email address");
                        jQuery(this).parent().parent().find(".validation_message").show();
                    }
                } else {
                    if (jQuery(this).parent(".gform-grid-col").length > 0) {
                        jQuery(this).parent(".gform-grid-col").removeClass("gfield_error");
                        jQuery(this).next(".validation_message").text("");
                        jQuery(this).parent(".gform-grid-col").find(".validation_message").hide();
                    } else {
                        jQuery(this).closest('.gfield').removeClass("gfield_error");
                        jQuery(this).parent().next(".validation_message").text("");
                        jQuery(this).parent().parent().find(".validation_message").hide();
                    }
                }
            } else {
                if (jQuery(this).parent(".gform-grid-col").length > 0) {
                    jQuery(this).parent(".gform-grid-col").removeClass("gfield_error");
                    jQuery(this).next(".validation_message").text("");
                    jQuery(this).parent(".gform-grid-col").find(".validation_message").hide();
                } else {
                    jQuery(this).closest(".gfield").removeClass("gfield_error");
                    jQuery(this).parent().next(".validation_message").text("");
                    jQuery(this).parent().parent().find(".validation_message").hide();
                }
            }
        }
    });
});

jQuery(window).on("load", function () {
    jQuery('.dataTable').each(function () {
        var $table = jQuery(this);
        if (isCsvTableVisible($table)) {
            initCsvDataTable($table);
        }
    });
});

jQuery(window).on("scroll", function () {
    onScrollEvents();
    mediaToolsStickyBar();
})

jQuery(window).on("resize", function () {
    onResizeEvents();

    setTimeout(function () {
        jQuery('.dataTable').each(function () {
            if (jQuery(this).find(".dtr-hidden").length > 0) {
                if (jQuery(this).find(".dtr-control").length > 0) {
                    jQuery(this).find(".dtr-control").removeClass("dtr-control-hid");
                }
            } else {
                if (jQuery(this).find(".dtr-control").length > 0) {
                    jQuery(this).find(".dtr-control").addClass("dtr-control-hid");
                }
            }
        });
    }, 500);
    offsetLeft();
})

function mediaToolsStickyBar() {
    if (jQuery(".media-tool-page__cart").length > 0) {
        if ((jQuery(window).scrollTop() + jQuery(window).outerHeight()) < jQuery(".fusion-footer").offset().top) {
            var top1 = jQuery(window).scrollTop() + (jQuery(window).outerHeight() - jQuery(".media-tool-page__cart").outerHeight());
            jQuery(".media-tool-page__cart").css("top", top1);
        }
    }
}

function checkCheckboxMediaTools() {
    var cCount = 0;
    jQuery(".single-media-tool .media-tools-row input[type=checkbox]:checked").each(function () {
        cCount++;
    })
    if (jQuery(".media-tool-page__cart").length > 0) {
        if (cCount > 0) {
            jQuery(".media-tool-page__cart").addClass("active")
        } else {
            jQuery(".media-tool-page__cart").removeClass("active")
        }
    }
    if (jQuery(".media-tool-cart__count .selected_items").length > 0) {
        jQuery(".media-tool-cart__count .selected_items").text(cCount);
    }
}

function onScrollEvents() {
    if (jQuery(".header-main-fusion-row .article-media-cart").length > 0) {
        if ((jQuery(window).scrollTop() > (jQuery(".header-main-fusion-row").offset().top - 200)) && jQuery(window).scrollTop() < (jQuery(".header-main-fusion-row").offset().top + (jQuery(".header-main-fusion-row").outerHeight() * 0.88))) {
            jQuery(".header-main-fusion-row .article-media-cart").css("top", (jQuery(window).scrollTop() - (jQuery(".header-main-fusion-row").offset().top - 200)));
            jQuery(".header-main-fusion-row .article-media-cart").addClass("scrolling");
        } else if (jQuery(window).scrollTop() < (jQuery(".header-main-fusion-row").offset().top - 200)) {
            jQuery(".header-main-fusion-row .article-media-cart").css("top", 0);
            jQuery(".header-main-fusion-row .article-media-cart").removeClass("scrolling");
        } else {
            jQuery(".header-main-fusion-row .article-media-cart").removeClass("scrolling");
        }

        // jQuery(".fusion-comments-tb").hide();
        var commentHeight = 0;
        if(jQuery(".fusion-comments-tb").length > 0)    {
            commentHeight = jQuery(".fusion-comments-tb").outerHeight();
        }
        var stepsBerak = ((jQuery(".header-main-fusion-row").outerHeight() - commentHeight) - (jQuery(window).height() * 0.5)) / 7;
        // jQuery(".fusion-comments-tb").show();
        // console.log('stepsBerak ' + stepsBerak);
        
        jQuery(".article-media-cart-sticky__progress .article-media-cart-sticky__step").each(function () {
            var index = jQuery(this).index();
            if (jQuery(window).scrollTop() > (jQuery(".header-main-fusion-row").offset().top + (stepsBerak * index))) {
                jQuery(this).addClass("active");
            } else {
                jQuery(this).removeClass("active");
            }
        })

        if (jQuery(window).width() < 961) {
            if (jQuery(window).scrollTop() > (jQuery(".header-main-fusion-row").offset().top - (jQuery(window).outerHeight() * 0.5))) {
                jQuery(".header-main-fusion-row .article-media-cart").addClass("show");
            } else {
                jQuery(".header-main-fusion-row .article-media-cart").removeClass("show");
            }
        }
    }
}

function onResizeEvents() {
    if (jQuery(".single_post_container").length > 0 && jQuery(".header-main-fusion-row .article-media-cart").length > 0) {
        if (jQuery(window).width() > 960) {
            jQuery(".header-main-fusion-row .article-media-cart").css({
                "left": jQuery(".single_post_container").offset().left + 20
            });
        } else {
            jQuery(".header-main-fusion-row .article-media-cart").css({
                "left": 0
            });
        }
    }
}

function cartEvents() {
    var cartItems = localStorage.getItem("cart_items");
    if (cartItems != "" && cartItems != "undefined" && cartItems != null) {
        cartItems = JSON.parse(cartItems);
        setCount(cartItems);
        fill_cart_items(cartItems);
    } else {
        if (jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").length > 0) {
            jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").removeClass("show");
        }
        if (jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").length > 0) {
            jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").removeClass("show");
        }
        jQuery("body").addClass("cart_is_empty");
    }


    jQuery(document).on("click", ".add_to_cart_btn, .article-media-cart-sticky__item.cart", function () {
        var cartItems = localStorage.getItem("cart_items");
        if (cartItems == "" || cartItems == "undefined" || cartItems == null) {
            cartItems = [];
            for (var i in window.downloadable_assets) {
                cartItems.push(window.downloadable_assets[i]);
            }
        } else {
            if (Array.isArray(cartItems)) {
                // cartItemsArr.concat(window.downloadable_assets)
                for (var i in window.downloadable_assets) {
                    cartItems.push(window.downloadable_assets[i]);
                }
                cartItems = [...new Set(cartItems)];
            } else {
                cartItems = JSON.parse(cartItems);
                for (var i in window.downloadable_assets) {
                    cartItems.push(window.downloadable_assets[i]);
                }
                cartItems = [...new Set(cartItems)];
                // cartItemsArr.concat(window.downloadable_assets)
            }
        }
        if (cartItems != "" && cartItems != "undefined" && cartItems != null) {
            cartItems = cartItems.map(JSON.stringify).filter((e, i, a) => i === a.indexOf(e)).map(JSON.parse);
        }
        fill_cart_items(cartItems);
        setCount(cartItems);
        localStorage.setItem("cart_items", JSON.stringify(cartItems));
    })
}

function fill_cart_items(Items) {
    var imageCount = 0;
    var documentCount = 0;
    var finalCart = "";
    for (let item in Items) {
        var currentObj = Items[item];
        var extension = currentObj.extension ? currentObj.extension : "";
        var filesize = currentObj.filesize ? currentObj.filesize : "";
        var height = currentObj.height ? currentObj.height : "";
        var id = currentObj.id ? currentObj.id : "";
        var link = currentObj.link ? currentObj.link : "";
        var thumbnail = currentObj.thumbnail ? currentObj.thumbnail : link;
        var title = currentObj.title ? currentObj.title : "";
        var type = currentObj.type ? currentObj.type : "";
        var width = currentObj.width ? currentObj.width : "";
        if (type != "" && type != undefined && type == "image") {
            imageCount++;
        }
        if (type != "" && type != undefined && type == "document") {
            documentCount++;
        }
        var htmlBase = fill_cart_item_block(type);
        if (type == "image") {
            htmlBase = htmlBase.replace("{1}", thumbnail);
            htmlBase = htmlBase.replace("{2}", link);
            htmlBase = htmlBase.replace("{3}", "");
        } else {
            htmlBase = htmlBase.replace("{4}", extension);
        }
        htmlBase = htmlBase.replace("{5}", title);
        htmlBase = htmlBase.replace("{6}", type);
        htmlBase = htmlBase.replace("{7}", filesize);
        htmlBase = htmlBase.replace("{8}", width + "x" + height + "px");
        htmlBase = htmlBase.replace("{9}", link);
        htmlBase = htmlBase.replace("{10}", type);
        htmlBase = htmlBase.replace("{11}", id);
        finalCart += htmlBase;
    }

    jQuery("#cart_item_list_main").html(finalCart);
    jQuery("#cart_all_count").text("(" + (imageCount + documentCount) + ")");
    jQuery("#image_all_count").text("(" + imageCount + ")");
    jQuery("#document_all_count").text("(" + documentCount + ")");
}

function fill_cart_item_block(type) {
    var cartHtml = "<div class='cart_item_list__item item_{10}' data-id='{11}'>";
    cartHtml += "<div class='cart_item_list__item__inner'>";
    cartHtml += "<div class='image_sec'>";
    if (type == "image") {
        cartHtml += "<div class='image_sec__inner image_item'>";
    } else {
        cartHtml += "<div class='image_sec__inner doc_item'>";
    }
    cartHtml += "<div class='image'>";
    if (type == "image") {
        cartHtml += "<img decoding='async' src='{1}' data-orig-src='{2}' class='img ls-is-cached lazyloaded' alt='{3}'>";
    } else {
        cartHtml += "<svg xmlns='http://www.w3.org/2000/svg' width='43' height='54' viewBox='0 0 43 54' class=''><path d='M42.394 30V9L33.31 0H0v54h42.394v-9h-3.028v6H3.028V3h27.254v9h9.084v18z' fill='#626366'></path></svg>";
        cartHtml += "<span class='media_item__text'>{4}</span>";
    }
    cartHtml += "</div>";
    cartHtml += "<div class='media_item_action_hover'>";
    cartHtml += "<a href='{9}' class='media_item_action_hover__btn download_btn' download>";
    cartHtml += "<svg xmlns='http://www.w3.org/2000/svg' width='23' height='23' viewBox='0 0 23 23' class=''>";
    cartHtml += "<path fill='#949CA1' stroke='#FFF' stroke-width='.5' d='M21.015 15.283c.27 0 .522.112.7.291.173.186.285.437.285.709v4.657c0 .062-.006.12-.016.177l-.017.081a.999.999 0 01-.972.802H1.998a.996.996 0 01-.985-.888C1 21.052 1 21 1 20.933v-4.657c0-.55.45-.993.992-.993a.994.994 0 01.992.993v3.73h17.039v-3.73c0-.55.45-.993.992-.993zM11.513 1c.318 0 .609.132.82.338.212.212.337.497.337.821v10.752l2.93-2.935c.45-.45 1.183-.45 1.64 0 .43.457.43 1.193-.02 1.643l-4.874 4.883c-.006.013-.02.02-.026.026-.179.179-.41.292-.641.325-.02 0-.04.006-.06.006l-.06.006H11.5l-.112-.006c-.02 0-.04-.006-.06-.006a1.127 1.127 0 01-.668-.351l-4.873-4.883a1.16 1.16 0 01-.337-.821c0-.298.112-.596.337-.822.45-.45 1.184-.45 1.64 0l2.93 2.935V2.159c0-.636.521-1.159 1.156-1.159z'></path>";
    cartHtml += "</svg>";
    cartHtml += "<span class='media_item_action_hover__btn__text'>download</span>";
    cartHtml += "</a>";
    cartHtml += "<button class='media_item_action_hover__btn delete_btn'>";
    cartHtml += "<svg xmlns='http://www.w3.org/2000/svg' width='26' height='30' viewBox='0 0 26 30' class=''>";
    cartHtml += "<path fill='#FFF' d='M15.131 0c1.44 0 2.845 1.03 3.24 2.376l.45 1.531h5.997c.653 0 1.182.515 1.182 1.15 0 .592-.46 1.08-1.053 1.142l-.129.006h-.4c.092.15.149.322.161.505l.002.125-.867 20.23c-.067 1.57-1.376 2.841-2.972 2.93l-.178.005H5.436c-1.616 0-2.98-1.217-3.137-2.762l-.013-.173-.867-20.23c-.01-.23.05-.446.162-.63h-.4C.53 6.205 0 5.691 0 5.056c0-.592.46-1.08 1.053-1.142l.129-.007h5.996l.45-1.53C8.007 1.088 9.31.09 10.681.005L10.87 0zm7.25 6.205H3.62c.075.123.127.262.15.41l.012.125.867 20.23c.015.361.32.675.687.725l.101.007h15.128a.805.805 0 00.777-.635l.011-.098.867-20.23a1.13 1.13 0 01.162-.534zM13 7.707c.485 0 .884.355.94.812l.005.107v15.628c0 .508-.423.92-.945.92a.937.937 0 01-.94-.812l-.005-.108V8.626c0-.508.423-.92.945-.92zm-5.228 0a.938.938 0 01.963.785l.01.107.473 15.628a.93.93 0 01-.917.946.938.938 0 01-.964-.785l-.01-.107-.472-15.628a.93.93 0 01.917-.946zm10.456 0c.484.014.873.38.914.839l.003.107-.473 15.628a.935.935 0 01-.973.892.935.935 0 01-.914-.838l-.003-.108.473-15.628a.935.935 0 01.973-.892zM15.13 2.298h-4.26c-.384 0-.862.35-.968.71l-.264.899h6.725l-.263-.9c-.096-.326-.5-.645-.861-.7l-.107-.009z'></path>";
    cartHtml += "</svg>";
    cartHtml += "<span class='media_item_action_hover__btn__text'>delete</span>";
    cartHtml += "</button>";
    cartHtml += "</div>";
    cartHtml += "</div>";
    cartHtml += "</div>";
    cartHtml += "<div class='item_content'>";
    cartHtml += "<div class='item_content__inner'>";
    cartHtml += "<div class='item_title'>{5}</div>";
    if (type == "image") {
        cartHtml += "<div class='item_size'>{6} ({7} — {8})</div>";
    } else {
        cartHtml += "<div class='item_size'>{6} ({7})</div>";
    }
    cartHtml += "</div>";
    cartHtml += "</div>";
    cartHtml += "</div>";
    cartHtml += "</div>";

    return cartHtml;
}

function setCount(Items) {
    cartItemsCount = 0;
    for (let item in Items) {
        cartItemsCount++;
    }
    if (jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").length > 0) {
        if (Array.isArray(Items) && cartItemsCount > 0) {
            var totalItemLength = cartItemsCount;
            jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").text(totalItemLength);
            jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").addClass("show");
        } else {
            jQuery(".header_controls .header__nav-wrap .header__nav-item--cart .header__nav-link .count").removeClass("show");
        }
    }
    if (jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").length > 0) {
        if (Array.isArray(Items) && cartItemsCount > 0) {
            var totalItemLength = cartItemsCount;
            jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").text(totalItemLength);
            jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").addClass("show");
        } else {
            jQuery(".fusion-body.single .single_header_social_share_column .header__nav-item--cart .secondary_header_cart_link .cart_count").removeClass("show");
        }
    }

    if (cartItemsCount > 0) {
        jQuery("body").removeClass("cart_is_empty");
    } else {
        setTimeout(function () {
            jQuery("body").addClass("cart_is_empty");
        }, 500);
    }
}

const validateEmail = (emailList) => {
    var valid = true;
    var emails = emailList.replace(/\s/g, '').split(",");
    var regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    for (var i = 0; i < emails.length; i++) {
        if (emails[i] == "" || !regex.test(emails[i])) {
            valid = false;
        }
    }

    return valid;
};


function filterPress(type) {
    var currentPostCount = jQuery(".press_releases_sec__inner__list__main > div:not(.press-releases-list__search)").length;
    var iPaged = jQuery("#prerelease_paged").val();
    var perpage = jQuery("#prerelease_pp").val();
    var category = jQuery("#prerelease_cat").val();
    paged = parseInt(iPaged);
    if (type == "loadmore") {
        paged = paged + 1;
    } else {
        paged = 1;
    }
    jQuery("#prerelease_paged").val(paged);

    jsonObj = {
        "action": "filter_press",
        "postperpage": parseInt(perpage),
        "paged": paged,
        "category": category,
        "currentPostCount": currentPostCount,
        "type": type,
    };
    jQuery.ajax({
        url: window.admin_aurl,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            //   console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                jQuery(".press_releases_sec__inner__list__main").html('<h3 class="not_found h3">Result not found!</h3>');
                jQuery(".press_releases_sec__inner__list__main").show();
                jQuery(".press_releases_sec__inner__list__loadmore").hide();
                return false;
            } else if (type == 'loadmore') {
                jQuery('.load_more_img').hide();
                jQuery(".press_releases_sec__inner__list__main").show();
                jQuery(".press_releases_sec__inner__list__main").append(data.data);
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".press_releases_sec__inner__list__main > div:not(.press-releases-list__search)").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".press_releases_sec__inner__list__loadmore").hide();
                    } else {
                        jQuery(".press_releases_sec__inner__list__loadmore").show();
                    }
                }
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 400);

        },
        error: function (xhr) {
            jQuery(".press_releases_sec__inner__list__main").show();
            console.log(xhr);
        }
    });
}

function filterTopicPosts(type) {
    var currentPostCount = jQuery(".topic_post_list_custom .story-bottom__inner > div").length;
    var iPaged = jQuery("#topic_paged").val();
    var perpage = jQuery("#topic_posts_per_page").val();
    var category = jQuery("#topic_post_category").val();
    var topicTtag = jQuery("#topic_tag").val();
    var linkText = jQuery("#topic_item_link_text").val();
    var exPosts = jQuery("#topic_exclude_posts").val();
    var paged = parseInt(iPaged);
    if (type == "loadmore") {
        paged = paged + 1;
    } else {
        paged = 1;
    }
    jQuery("#topic_paged").val(paged);

    jsonObj = {
        "action": "filter_topic_posts",
        "postperpage": parseInt(perpage),
        "paged": paged,
        "category": category,
        "currentPostCount": currentPostCount,
        "linkText": linkText,
        "topicTag": topicTtag,
        "excludePosts": exPosts,
        "type": type,
    };
    jQuery.ajax({
        url: window.admin_aurl,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            //   console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                jQuery(".topic_post_list_custom .story-bottom__inner").html('<h3 class="not_found h3">Result not found!</h3>');
                jQuery(".topic_post_list_custom .story-bottom__inner").show();
                jQuery(".topic_post_list_custom .load-more").hide();
                return false;
            } else if (type == 'loadmore') {
                jQuery('.load_more_img').hide();
                jQuery(".topic_post_list_custom .story-bottom__inner").show();
                jQuery(".topic_post_list_custom .story-bottom__inner").append(data.data);
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".topic_post_list_custom .story-bottom__inner > div").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".topic_post_list_custom .load-more").hide();
                    } else {
                        jQuery(".topic_post_list_custom .load-more").show();
                    }
                }
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 400);

        },
        error: function (xhr) {
            jQuery(".topic_post_list_custom .story-bottom__inner").show();
            console.log(xhr);
        }
    });
}

function LoadMoreSearchResult(type) {
    var currentPostCount = jQuery(".topic_post_list_custom .story-bottom__inner > div").length;
    var iPaged = jQuery("#search_paged").val();
    var perpage = jQuery("#search_posts_per_page").val();
    var keyword = jQuery("#search_keyword").val();
    var paged = parseInt(iPaged);
    if (type == "loadmore") {
        paged = paged + 1;
    } else {
        paged = 1;
    }
    jQuery("#topic_paged").val(paged);

    jsonObj = {
        "action": "loadmore_search_result",
        "postperpage": parseInt(perpage),
        "paged": paged,
        "keyword": keyword,
        "currentPostCount": currentPostCount,
        "type": type,
    };
    jQuery.ajax({
        url: window.admin_aurl,
        data: jsonObj, // form data
        type: "POST", // POST
        async: true,
        beforeSend: function (xhr) {
            console.log("ajax start"); // changing the button label
        },
        success: function (data) {
            //   console.log(data.data);

            if (data.data.replace(/(\r\n\t|\n|\r\t)/gm, "").replace(" ", "") == "false" && type != 'loadmore') {
                jQuery(".topic_post_list_custom .story-bottom__inner").html('<h3 class="not_found h3">Result not found!</h3>');
                jQuery(".topic_post_list_custom .story-bottom__inner").show();
                jQuery(".topic_post_list_custom .load-more").hide();
                return false;
            } else if (type == 'loadmore') {
                jQuery('.load_more_img').hide();
                jQuery(".topic_post_list_custom .story-bottom__inner").show();
                jQuery(".topic_post_list_custom .story-bottom__inner").append(data.data);
            }

            setTimeout(function () {
                var total = jQuery("#total_post_count").val();
                var current = jQuery("#current_post_count").val();

                var c_total = jQuery(".topic_post_list_custom .story-bottom__inner > div").length;
                if (total != '' && current != '') {
                    if (parseInt(total) == c_total) {
                        jQuery(".topic_post_list_custom .load-more").hide();
                    } else {
                        jQuery(".topic_post_list_custom .load-more").show();
                    }
                }
                jQuery("#total_post_count").remove();
                jQuery("#current_post_count").remove();
            }, 400);

        },
        error: function (xhr) {
            jQuery(".topic_post_list_custom .story-bottom__inner").show();
            console.log(xhr);
        }
    });
}

function setSingleItemToCart(assetObject) {
    var cartItems = localStorage.getItem("cart_items");
    if (cartItems == "" || cartItems == "undefined" || cartItems == null) {
        cartItems = [];
        cartItems.push(assetObject);
    } else {
        if (Array.isArray(cartItems)) {
            // cartItemsArr.concat(window.downloadable_assets)
            for (var i in window.downloadable_assets) {
                cartItems.push(assetObject);
            }
            cartItems = [...new Set(cartItems)];
        } else {
            cartItems = JSON.parse(cartItems);
            for (var i in window.downloadable_assets) {
                cartItems.push(assetObject);
            }
            cartItems = [...new Set(cartItems)];
            // cartItemsArr.concat(window.downloadable_assets)
        }
    }
    if (cartItems != "" && cartItems != "undefined" && cartItems != null) {
        cartItems = cartItems.map(JSON.stringify).filter((e, i, a) => i === a.indexOf(e)).map(JSON.parse);
    }
    fill_cart_items(cartItems);
    setCount(cartItems);
    localStorage.setItem("cart_items", JSON.stringify(cartItems));
}

function isCsvTableVisible($table) {
    var $section = $table.closest('.csv_file_sec');
    if ($section.length) {
        return $section.is(':visible');
    }
    return $table.is(':visible');
}

function updateCsvDataTableControls($table) {
    if ($table.find(".dtr-hidden").length > 0) {
        if ($table.find(".dtr-control").length > 0) {
            $table.find(".dtr-control").removeClass("dtr-control-hid");
        }
    } else if ($table.find(".dtr-control").length > 0) {
        $table.find(".dtr-control").addClass("dtr-control-hid");
    }
}

function redrawCsvDataTable($table) {
    if (!jQuery.fn.DataTable || !jQuery.fn.DataTable.isDataTable($table[0])) {
        return;
    }
    var api = $table.DataTable();
    api.columns.adjust();
    api.draw(false);
    updateCsvDataTableControls($table);
}

function initCsvDataTable($table) {
    if (!jQuery.fn.DataTable) {
        return;
    }

    if (jQuery.fn.DataTable.isDataTable($table[0])) {
        redrawCsvDataTable($table);
        return;
    }

    if (!isCsvTableVisible($table)) {
        return;
    }

    var entries = 5;
    var entriesVal = $table.attr("data-entries");
    if (entriesVal !== "" && entriesVal !== undefined && entriesVal !== null) {
        entries = parseInt(entriesVal, 10);
    }

    $table.DataTable({
        info: false,
        bLengthChange: false,
        bFilter: true,
        ordering: false,
        pageLength: entries,
        iDisplayLength: entries,
        layout: {
            topStart: null,
            topEnd: 'search',
            bottomStart: null,
            bottomEnd: {
                paging: {
                    buttons: 7
                }
            }
        },
        initComplete: function () {
            var api = this.api();
            var $el = jQuery(api.table().node());
            requestAnimationFrame(function () {
                api.columns.adjust();
                api.draw(false);
                updateCsvDataTableControls($el);
            });
        }
    });

    updateCsvDataTableControls($table);
}

function initVisibleCsvDataTables($context) {
    jQuery($context || document).find('.dataTable').each(function () {
        initCsvDataTable(jQuery(this));
    });
}

function offsetLeft() {
    if ((jQuery('.custom_image_carousel_sec_outer .custom_image_carousel_sec_swiper').length > 0)) {
        var applicationsoffset = jQuery('.custom_image_carousel_sec_outer .custom_image_carousel_sec_swiper').offset(),
            applicationswindWidth = jQuery(window).width();
        jQuery('.custom_image_carousel_sec_outer .custom_image_carousel_sec_swiper').css('width', (applicationswindWidth - applicationsoffset.left));
    }
}